/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import { navigate, useLocation } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
const { selectLoginStatus } = Slices.authSlice;
const { selectDesktop } = Slices.appSlice;
import DialogBox from '../DialogBox';
import Login from '../../containers/Login';
import Skeleton from 'react-loading-skeleton';
import css from './index.module.scss';
import EllipsisText from '../EllipsisText';
import profileAvtar from './profile.svg';

const LoginButton = ({ onClick, className }) => {
  const location = useLocation();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);
  const isLoggedIn = useSelector(selectLoginStatus);
  const profile = useSelector((state) => state.profile);
  const profileData = profile?.data?.data?.[0];
  const [isLoginDialogOpen, setLoginDialogOpen] = useState(false);

  const handleClick = (e) => {
    if (isDesktop) {
      // navigate(location.pathname + '?modal=login');
      navigate(`/${intl.locale}/login`, {
        state: { oldLocation: JSON.parse(JSON.stringify(location)) },
      });
    } else {
      navigate('/login');
    }
  };

  const handleLoginDialogClose = (e) => {
    navigate(-1);
  };

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    if ((search.get('modal') || '').toLowerCase() === 'login') {
      setLoginDialogOpen(true);
    } else {
      setLoginDialogOpen(false);
    }
  }, [location.search]);

  const stepVerify = profileData?.profileStep;
  const handleProfile = () => {
    if (stepVerify || (profileData.profileStep === 0 && profileData.email !== '')) {
      navigate(`/${intl.locale}/profile`, {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
        },
      });
    } else {
      navigate(`/${intl.locale}/create-profile`, {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
        },
      });
    }
  };

  const renderLoginButton = () => {
    if (isLoggedIn === null) {
      return <Skeleton count={1} className={css.Skeleton} />;
    } else if (isLoggedIn === false) {
      return (
        <Button className={css.root} variant="contained" color="primary" onClick={handleClick}>
          <FormattedMessage id="navigation_login" defaultMessage="login" />
        </Button>
      );
    } else {
      return (
        <div className={css.loggedUser} onClick={handleProfile}>
          <div className={css.avatar}>
            <img src={profileAvtar} alt="Profile Avtar" className={css.profileAvtar} />
            {profileData?.name.toUpperCase()[0]}
          </div>
          <div className={css.title}>
            <EllipsisText limit={8} data={profileData?.name || ''}></EllipsisText>
            {stepVerify === 0 && profileData.email === '' && (
              <FormattedMessage id="pleaseCreateProfile" defaultMessage="Please Create Profile" />
            )}
          </div>
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      {renderLoginButton()}
      <DialogBox
        title=""
        size="sm"
        height="55.5rem"
        titleDesc=""
        isOpen={isLoginDialogOpen}
        hideCloseButton={true}
        onClose={handleLoginDialogClose}
        page="login"
      >
        <DialogContent dividers={true}>
          <Login />
        </DialogContent>
      </DialogBox>
    </React.Fragment>
  );
};

export default LoginButton;
